import { defineMessages } from 'react-intl-next';

export default defineMessages({
    showMoreText: {
        defaultMessage: 'Show {count, plural, one {# more} other {# more}}',
        description: 'Text to show the count of the other help objects.',
        id: 'cv.help.topics.show.more',
    },
});
